import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import { HdsAlert } from '@hashicorp/design-system-components/components';

const DefaultRoleAdmin = <template>
  <HdsAlert
    data-test-sso-banner-default-role-admin
    @type="page"
    @color="warning"
    as |A|
  >
    <A.Title>
      {{t "components.sso.banner.default-role-admin.title"}}
    </A.Title>

    <A.Description>
      {{t "components.sso.banner.default-role-admin.description"}}
    </A.Description>

    {{#if (eq @ssoType "OIDC")}}
      <A.LinkStandalone
        data-test-sso-banner-default-role-admin-link="OIDC"
        @icon="arrow-right"
        @iconPosition="trailing"
        @model={{@model.organization.id}}
        @route="cloud.orgs.detail.settings.sso.oidc.configure"
        @text={{t "components.sso.banner.default-role-admin.link.text"}}
      />
    {{else if (eq @ssoType "SAML")}}
      <A.LinkStandalone
        data-test-sso-banner-default-role-admin-link="SAML"
        @icon="arrow-right"
        @iconPosition="trailing"
        @model={{@model.organization.id}}
        @route="cloud.orgs.detail.settings.sso.saml.configure"
        @text={{t "components.sso.banner.default-role-admin.link.text"}}
      />
    {{else}}
      <A.LinkStandalone
        data-test-sso-banner-default-role-admin-link="UNSET"
        @icon="arrow-right"
        @iconPosition="trailing"
        @model={{@model.organization.id}}
        @route="cloud.orgs.detail.settings.sso.select-method"
        @text={{t "components.sso.banner.default-role-admin.link.text"}}
      />
    {{/if}}
  </HdsAlert>
</template>;

export default DefaultRoleAdmin;
